import React from 'react';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import useLegalRepresentativesPanel from '../../hooks/useLegalRepresentativesPanel';
import TitleComponent from './TitleComponent';
import LegalRepresentativeItem from './LegalRepresentativeItem';
import CONTRACT_INPUT_LABEL_PROPS from './inputs/contractInputLabelProps';

const LegalRepresentativesComponent = ({
  legalRepresentatives,
  availableRepresentatives,
  addLegalRepresentative,
  removeLegalRepresentative,
  updateLegalRepresentative,
}) => {
  const {
    expandedId,
    setExpandedId,
    selectedRepresentatives,
    availableToSelect,
    handleSelectRepresentative,
    handleAddAnother,
    handleRemove,
  } = useLegalRepresentativesPanel({
    legalRepresentatives,
    availableRepresentatives,
    addLegalRepresentative,
    removeLegalRepresentative,
  });

  return (
    <>
      <TitleComponent number="2" label="Representantes Legales:" />
      <Stack spacing={2} sx={{ px: 2 }}>
        {availableToSelect.length > 0 && (
          <TextField
            select
            fullWidth
            label="Seleccionar"
            value=""
            onChange={handleSelectRepresentative}
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
          >
            <MenuItem value="" disabled sx={{ display: 'none' }} />
            {availableToSelect.map((rep) => (
              <MenuItem key={rep.id} value={rep.id}>
                {rep.name}
              </MenuItem>
            ))}
          </TextField>
        )}

        {selectedRepresentatives.map((representative) => (
          <LegalRepresentativeItem
            key={representative.id}
            representative={representative}
            expanded={expandedId === representative.id}
            onExpandedChange={(isExpanded) => {
              setExpandedId(isExpanded ? representative.id : null);
            }}
            onUpdate={updateLegalRepresentative}
            onRemove={handleRemove}
          />
        ))}

        <Stack direction="row" justifyContent="flex-end">
          <Link
            component="button"
            type="button"
            variant="body2"
            underline="always"
            onClick={handleAddAnother}
            sx={{ cursor: 'pointer' }}
          >
            + Agregar otro
          </Link>
        </Stack>
      </Stack>
    </>
  );
};

LegalRepresentativesComponent.propTypes = {
  legalRepresentatives: PropTypes.arrayOf(PropTypes.shape).isRequired,
  availableRepresentatives: PropTypes.arrayOf(PropTypes.shape).isRequired,
  addLegalRepresentative: PropTypes.func.isRequired,
  removeLegalRepresentative: PropTypes.func.isRequired,
  updateLegalRepresentative: PropTypes.func.isRequired,
};

export default LegalRepresentativesComponent;
